import { ThemeProvider } from "@mui/material";

import { MaterialUIControllerProvider } from "@/contexts/mui-context";
import themes from "@/themes";

type StyleProvidersProps = {
  children: React.ReactNode;
  [key: string]: any;
};

const themeKey = "default"; // Sempre usar o tema default para simplificar
const theme = themes[themeKey];

// Garantir que o tema seja válido
if (!theme) {
  // console.error(`Theme "${themeKey}" not found. Available themes:`, Object.keys(themes));
  throw new Error(`Theme "${themeKey}" not found`);
}

export default function StyleProviders({ children, ...props }: StyleProvidersProps) {
  // Filter out Lovable-specific props to prevent warnings
  const filteredProps = Object.keys(props).reduce(
    (acc, key) => {
      if (!key.startsWith("data-lov-") && !key.startsWith("data-component-")) {
        acc[key] = props[key];
      }
      return acc;
    },
    {} as Record<string, any>
  );

  return (
    <MaterialUIControllerProvider {...filteredProps}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </MaterialUIControllerProvider>
  );
}
